import axios from "axios";

const apiInstance = axios.create({
   // Use the current site origin (https://sk-hotline.kz in production, localhost in dev).
   // This avoids hardcoded localhost URLs in users' browsers.
   baseURL: "/",
});


const postMessage = (formData: FormData, navigate: (code: string) => void) => {
    apiInstance
        .post("/api/ExtDictionary/PostQuestionnaireData", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
        .then((response) => {
            navigate(response.data);
        })
        .catch((error) => {
            console.error("Error:", error);
            navigate("");
        });
};


export interface UserFrontStatusAnswerFiles {
  name: string;
  bytes: number[];
  path: string;
}

export interface UserFrontStatusAnswer {
  ReviewerComment: string;
  messageText: string;
  messageId: string;
  files: UserFrontStatusAnswerFiles[];
}

type GetStatus = (
  data: string,
  callback: (status: UserFrontStatusAnswer | null) => void,
) => void;

const getStatus: GetStatus = (data, callback) => {
  apiInstance
    .get<UserFrontStatusAnswer>(
        `/api/ExtDictionary/GetStatus?requestCode=${data}`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )
    .then((response) => {
      callback(response.data);
    })
    .catch((error) => {
      console.error("Error:", error);
      callback(null);
    });
};

export { postMessage, getStatus };
